import React from 'react';
import SectionTitle from '../../components/content/SectionTitle';
import Waiting from '../../components/content/Waiting';
import BlockingModal from '../../components/framework/BlockingModal';

const ThankYouPage: React.FC = () => {
  return (
    <BlockingModal isOpen>
      <div style={{ width: 275 }}>
        <SectionTitle className="text-center">
          Completing your order
        </SectionTitle>
        <Waiting />
      </div>
    </BlockingModal>
  );
};

export default ThankYouPage;
